/* eslint-disable import/prefer-default-export */
export const getUserEmail = () => window.Office.context.mailbox.initialData?.userEmailAddress;
